// src/hooks/useCityContent.js
import cityContent from "../api/cityContent";
import useCityQueryParam from "./useQueryParam";

const useCityContent = () => {
  const cityParam = useCityQueryParam();
  const cityData = cityContent[0][cityParam] || cityContent[0]["ahmedabad"];
  return { cityParam, cityData };
};

export default useCityContent;
